import { analyticsAndInsights } from './analytics-and-insights';
import { artificialIntelligence } from './artificial-intelligence';
import { campaignManagement } from './campaign-management';
import { cmsExtension } from './cms-extension';
import { developerTools } from './developer-tools';
import { eCommerce } from './e-commerce';
import { headless } from './headless';
import { pimDam } from './pim-dam';
import { search } from './search';
import { themesAndStarterKits } from './themes-and-starter-kits';
import { translations } from './translations';

export {
  analyticsAndInsights,
  artificialIntelligence,
  campaignManagement,
  cmsExtension,
  developerTools,
  eCommerce,
  headless,
  pimDam,
  search,
  themesAndStarterKits,
  translations,
};

export const categoryIcons = [
  analyticsAndInsights,
  artificialIntelligence,
  campaignManagement,
  cmsExtension,
  developerTools,
  eCommerce,
  headless,
  pimDam,
  search,
  themesAndStarterKits,
  translations,
];
